module.exports = {
  AudioCue: {
    config: "Konfigürasyon",
    PluginName: "Ses İşareti",
    AutoPlay: "Otomatik Oynat",
    URL: "Ses URL",
    Image: "Resim URL",
    Color: "Renk",
    UseImage: "Resim Kullan",
    HideAnimation: "Animasyonu Gizle",
    PlayerView: "Oynatıcı Görünümü",
    IsSoundRecord: "Ses Kaydet",
    SoundRecorder: "Geçen Süre",
    Start: "Başlat",
    Stop: "Durdur",
    SoundRecording: "Ses Kaydediliyor...",
    SoundRecorded: "Ses Kaydedildi.",
    SelectSoundProvider: "Ses Parçası Ekle",
    AddSound: "Ekle",
    EndTime: "Sahnedeki Bitiş Süresi",
    StartTime: "Sahnedeki Başlangıç Süresi",
    Save: "Kaydet",
  },
};
